// frontend-web/src/pages/Admin/UploadCSV.js

import React, { useState } from "react";
import api from "../../api";

const UploadCSV = () => {
  const [file, setFile] = useState(null);
  const [message, setMessage] = useState("");
  const [loading, setLoading] = useState(false);

  const handleUpload = async () => {
    if (!file) {
      setMessage("❌ Please select a CSV file first.");
      return;
    }

    const formData = new FormData();

    // ⚠️ IMPORTANT:
    // Backend usually expects "file"
    // If backend expects "csv_file", change key here
    formData.append("file", file);

    try {
      setLoading(true);
      setMessage("");

      const response = await api.post(
        "/admin/upload_questions_csv", // ✅ staging backend route
        formData
        // ❌ headers mat bhejo – interceptor handle karega
      );

      setMessage(
        response?.data?.message ||
          "✅ CSV uploaded successfully!"
      );
      setFile(null);
      document.getElementById("file-input").value = "";
    } catch (error) {
      console.error("CSV Upload Error:", error?.response);

      const errMsg =
        error?.response?.data?.message ||
        error?.response?.data?.msg ||
        "❌ Upload failed. Please check CSV format.";

      setMessage(errMsg);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div style={{ padding: "20px", maxWidth: "600px" }}>
      <h2>Upload Questions CSV</h2>

      <p style={{ fontSize: "14px", color: "#aaa" }}>
        <strong>Expected format:</strong><br />
        type,class,subject,text,option1,option2,option3,option4,correct
      </p>

      <input
        id="file-input"
        type="file"
        accept=".csv"
        onChange={(e) => setFile(e.target.files[0])}
      />

      <br />

      <button
        onClick={handleUpload}
        disabled={loading}
        style={{
          marginTop: "10px",
          padding: "8px 16px",
          backgroundColor: "#2e7d32",
          color: "#fff",
          border: "none",
          cursor: "pointer",
        }}
      >
        {loading ? "Uploading..." : "Upload CSV"}
      </button>

      {message && (
        <p
          style={{
            marginTop: "12px",
            color: message.startsWith("✅") ? "green" : "red",
          }}
        >
          {message}
        </p>
      )}
    </div>
  );
};

export default UploadCSV;
